import React from 'react';

interface ProviderCardSkeletonProps {
  count?: number;
}

const ProviderCardSkeleton: React.FC<ProviderCardSkeletonProps> = ({ count = 3 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="bg-white rounded-xl sm:rounded-2xl shadow-md overflow-hidden animate-pulse"
        >
          {/* Image placeholder */}
          <div className="h-36 sm:h-48 bg-gray-200" />
          
          {/* Content */}
          <div className="p-3 sm:p-5 space-y-3 sm:space-y-4">
            {/* Name */}
            <div className="h-4 sm:h-5 bg-gray-200 rounded w-3/4" />
            
            {/* Category/Type badge */}
            <div className="h-5 sm:h-6 bg-gray-200 rounded-full w-24" />
            
            {/* Rating */}
            <div className="flex items-center gap-2">
              <div className="h-4 bg-gray-200 rounded w-16" />
              <div className="h-4 bg-gray-200 rounded w-20" />
            </div>
            
            {/* Location */}
            <div className="flex items-center gap-2">
              <div className="h-3 w-3 bg-gray-200 rounded" />
              <div className="h-3 sm:h-4 bg-gray-200 rounded w-1/2" />
            </div>
            
            {/* Services tags */}
            <div className="flex gap-2">
              <div className="h-5 sm:h-6 bg-gray-200 rounded-full w-16" />
              <div className="h-5 sm:h-6 bg-gray-200 rounded-full w-20" />
              <div className="h-5 sm:h-6 bg-gray-200 rounded-full w-14" />
            </div>
            
            {/* Button */}
            <div className="h-9 sm:h-10 bg-gray-200 rounded-lg w-full mt-3 sm:mt-4" />
          </div>
        </div>
      ))}
    </>
  );
};

export default ProviderCardSkeleton;
